import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'underscore';
import { Link, Grid, Tooltip, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataTable } from 'components';
import { DeleteAttachFile } from '../../../../../actions/TicketsActions';

const useStyles = makeStyles((theme) => ({
	root: {},
	deleteButton: {
		color: theme.palette.error.main
	}
}));

const FilesDataTable = (props) => {
	const { files, DownloadFile, DeleteFile, userId } = props;
	const classes = useStyles();
	const _DeleteFile = (fileId) => {
		DeleteFile(fileId);
	};

	const _DownloadFile = (fileName) => {
		DownloadFile(fileName);
	};

	const _getTableColumns = () => [
		{
			name: 'id',
			label: 'Id',
			options: {
				display: false,
				filter: false,
				viewColumns: false,
				filterType: 'textField',
			}
		},
		{
			name: 'fileName',
			label: 'Name',
			options: {
				filterType: 'textField',
				customBodyRender: (value, tableMeta, updateValue) => {
					const { rowData } = tableMeta;
					const file = _.find(files, (item) => item.id === rowData[0]);
					return file ? (
						<Link
							component="button"
							variant="body2"
							onClick={() => _DownloadFile(file.fileName)}
							style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
							underline="hover"
						>
							{value}
						</Link>
					) : (value);
				}
			}
		},
		{
			name: 'creationTimestamp',
			label: 'Date',
			options: {
				filterType: 'textField',
				customBodyRender: (value) => (
					value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : value
				)
			}
		},
		{
			name: 'userName',
			label: 'By',
			options: {
				filterType: 'textField',
			}
		},
		{

			name: 'action',
			label: 'Actions',
			options: {
				display: true,
				filter: false,
				sort: false,
				viewColumns: false,
				empty: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const { rowData } = tableMeta;
					const file = _.find(files, (item) => item.id === rowData[0]);
					return file && (
						<Tooltip title="Delete" aria-label="delete">
							<IconButton
								id="delete_file"
								className={classes.deleteButton}
								onClick={() => _DeleteFile(rowData[0])}
								disabled={!_.isEqual(userId, file.attachedBy)}
								size="large"
							>
								<DeleteIcon />
							</IconButton>
						</Tooltip>
					);
				}
			}
		},
	];

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: false,
		expandableRows: false, // Try Adding This
		pagination: false,
		filter: false,
		search: false,
		viewColumns: false,
		sort: false
	});

	return (
		<Grid container spacing={3}>
			<Grid item lg={12} xs={12}>
				<DataTable
					id="PlanStepFilesTabDataTable"
					title=""
					data={files}
					columns={_getTableColumns()}
					rowsPerPage={15}
					tableBodyCellMaxWidth={250}
					options={_getTableOptions()}
				/>
			</Grid>
		</Grid>

	);
};

FilesDataTable.propTypes = {
	files: PropTypes.array.isRequired,
	DownloadFile: PropTypes.func,
	DeleteFile: PropTypes.func,
	userId: PropTypes.string
};

export default FilesDataTable;
